var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 153,
    height: 184,
    viewBox: "0 0 153 184",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill-rule: evenodd;\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 129.616,
    x2: 23.384,
    y2: 184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#04dc78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#04dc78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0773e5"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M153.011,43.776c0,24.138-18.649,43.777-41.576,43.777H81.96L61.2,127.7,48.22,105.031l24.331-52h34.743a8.129,8.129,0,0,0,0-16.256l-87.5-.034-5.9,14.13H52.9L28.954,104.1l31.591,60.3L96.164,98.846l1.2-2.216h10.513l-0.669,1.23L60.41,184,19.174,105.346l-0.432-.827,1.156-2.543L38.875,60.234H0L13.71,27.376,107.3,27.414a17.493,17.493,0,0,1-.009,34.98h-28.9l-19.91,42.435,2.888,5.661,15.59-32.33h9.86L86.8,78.19h24.634c17.856,0,32.379-15.438,32.379-34.415S129.291,9.364,111.435,9.364h-58.3L69.23,0h42.2C134.362,0,153.011,19.64,153.011,43.776Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoicon);
export default __webpack_public_path__ + "static/media/logoicon.3726387c60a3c3f3133ad21ab83b95c8.svg";
export { ForwardRef as ReactComponent };